import { HTTP } from '../config/http-common';
import { ROUTE_API } from '../constants/routes';
import { exportResults, convertParams } from '../utils/index';

export const findOne = async (id, params) =>
    exportResults(
        await HTTP.get(`${ROUTE_API.TEST}/${id}`, {
            params: convertParams(params),
        }),
    );

export const attemptTest = async (payload) => exportResults(await HTTP.post(ROUTE_API.ATTEMPT_TEST, payload));
